"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardStatusIconsDefaultTexts = exports.CardStatusIcons = exports.CardStatusIconColors = exports.CardStatusBorderColors = exports.CardDefaultProps = exports.CARD_STATUS_ICON_SPACING = exports.CARD_STATUS_BORDER_WIDTH = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _iconAlertCircleFillMedium = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-alert-circle-fill-medium"));
var _iconAlertTriangleFillMedium = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-alert-triangle-fill-medium"));
var _iconCheckCircleFillMedium = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-check-circle-fill-medium"));
var _iconInformationFillMedium = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-information-fill-medium"));
var _layout = require("../layout");
var _interfaces = require("./interfaces");
const CARD_STATUS_BORDER_WIDTH = exports.CARD_STATUS_BORDER_WIDTH = 8;
// TODO: use 300 (or padding from default props) when border is placed on the left in scope of https://sim.amazon.com/issues/Stencil-1363
const CARD_STATUS_ICON_SPACING = exports.CARD_STATUS_ICON_SPACING = (0, _utils.token)('dimensions.spacing.200');
const CardStatusBorderColors = exports.CardStatusBorderColors = {
  [_interfaces.CardStatus.Informational]: 'color.status.info-fill',
  [_interfaces.CardStatus.Success]: 'color.status.success-fill',
  [_interfaces.CardStatus.Warning]: 'color.status.warning-fill',
  [_interfaces.CardStatus.Error]: 'color.status.critical-fill'
};
const CardStatusIcons = exports.CardStatusIcons = {
  [_interfaces.CardStatus.Informational]: _iconInformationFillMedium.default,
  [_interfaces.CardStatus.Success]: _iconCheckCircleFillMedium.default,
  [_interfaces.CardStatus.Warning]: _iconAlertTriangleFillMedium.default,
  [_interfaces.CardStatus.Error]: _iconAlertCircleFillMedium.default
};
const CardStatusIconsDefaultTexts = exports.CardStatusIconsDefaultTexts = {
  [_interfaces.CardStatus.Informational]: 'Information',
  [_interfaces.CardStatus.Success]: 'Success!',
  [_interfaces.CardStatus.Warning]: 'Warning',
  [_interfaces.CardStatus.Error]: 'Error'
};
const CardStatusIconColors = exports.CardStatusIconColors = {
  [_interfaces.CardStatus.Informational]: 'color.status.info-icon',
  [_interfaces.CardStatus.Success]: 'color.status.success-icon',
  [_interfaces.CardStatus.Warning]: 'color.status.warning-icon',
  [_interfaces.CardStatus.Error]: 'color.status.critical-icon'
};
const CardDefaultProps = exports.CardDefaultProps = {
  ..._layout.View.defaultProps,
  display: 'flex',
  backgroundColor: (0, _utils.token)('color.surface.bg-default'),
  padding: (0, _utils.token)('dimensions.spacing.300'),
  status: _interfaces.CardStatus.Default
};